import { useAtomValue } from 'jotai';
import { zendeskChatServiceAtom } from './zendesk.atoms';

export default function useZendeskChat() {
	return useAtomValue(zendeskChatServiceAtom);
}
